export enum ClassSubpage {
    AllStudents,
    AbsentStudents,
    Homework,
    ModifiedSchedule,
    UsualSchedule,
}
